import { ModalRef } from '@msdk/common'
import React, { Suspense } from 'react'

interface Props {
  modalRef?: ModalRef
  children: React.ReactElement
}

/**
 * Wrapper to ensure the modalRef to a specific modal is passed down to the modal itself.
 * Creates a clone of the passed child and injects the modalRef, wrapping it in a suspense to prevent flickering.
 */
export function ModalSuspenseWrapper(props: Props) {
  const { children, modalRef } = props

  const child = React.cloneElement(children, { ...children.props, modalRef })

  return <Suspense>{child}</Suspense>
}
